import { FC, Fragment, MutableRefObject } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button, Flex, Input, Tag, Typography } from "antd";

import { ChangeEnum } from "@/types/inventory";
import { User, UserPermissionEnum } from "@/types/user";
import { Org } from "@/types/org";

import useOrgStatus from "@/pages/Warehouse/hooks/useOrgStatus";
import { RootState } from "@/store";
import { HeaderWrap } from "@/pages/Warehouse/style";
import { DEFAULT_PAGE_SIZE, TableLayoutRef } from "@/styles/STableLayout";
import { StoreTypeEnum } from "@/types/product";
import { hasPermission } from "@/utils/user";

const { Title } = Typography;

interface InventoryHeaderProps {
  inOutLoading: ChangeEnum | undefined;
  setInOutLoading: (value: ChangeEnum | undefined) => void;
  keyword: string;
  setKeyword: (value: string) => void;
  tableRef: MutableRefObject<TableLayoutRef | null>;
  fetch: (keyword: string, offset: number, take: number) => void;
  setOpen: (value: ChangeEnum | undefined) => void;
  categoryName: string;
  type: StoreTypeEnum;
  setOnOpen: (value: ChangeEnum.IN | ChangeEnum.OUT | undefined) => void;
}

export const InventoryHeader: FC<InventoryHeaderProps> = ({
  inOutLoading,
  setInOutLoading,
  keyword,
  setKeyword,
  tableRef,
  fetch,
  setOpen,
  categoryName,
  setOnOpen,
  type,
}) => {
  const { t } = useTranslation();

  const curOrg: Org = useSelector(
    (state: RootState) => state.orgReducer.curOrg
  );
  const curUser: User = useSelector(
    (state: RootState) => state.userReducer.curUser
  );

  const getHasPermission = (key: UserPermissionEnum) => {
    return hasPermission(curUser, [UserPermissionEnum.ADMIN, key]) || hasPermission(curUser, [UserPermissionEnum.ADMIN])
  }

  const getPermissionBtn = (permission: ChangeEnum.IN | ChangeEnum.OUT, text: string, per: UserPermissionEnum) => {
    return (
      getHasPermission(per) && (
        <Button
          type="primary"
          loading={inOutLoading === permission}
          disabled={inOutLoading && inOutLoading !== permission}
          // onClick={() => onStoreClick(permission)}
          onClick={() => setOnOpen(permission)}
        >
          {text}
        </Button>
      )
    );
  };


  return (
    <Fragment>
      <Title className="category-name" level={4}>
        {categoryName}
      </Title>
      {/* <Tag color={storeTypeObj[type].color}>{storeTypeObj[type].name}</Tag> */}
      {getPermissionBtn(ChangeEnum.IN, t("warehouse.inboundOprt"), UserPermissionEnum.ACT_STORE_IN)}
      {getPermissionBtn(ChangeEnum.OUT, t("warehouse.outboundOprt"), UserPermissionEnum.ACT_STORE_OUT)}
    </Fragment>
  );
};
